import authInstance from '../../utils/axios/authInstance';
import {encodeData} from '../../utils/url';
import queryString from 'query-string';

export const getEmployersService = (page: number, per_page: number, search: string) => {
  const data = {
    page: page,
    per_page: per_page,
    company_name: search,
  }
  const params = encodeData(data);
  return authInstance.get(`employers?${params}`);
}

export const getEmployerService = (companySlug: string) => {
  return authInstance.get(`employers/${companySlug}`);
}

export const getEmployerJobsService = (page: number, per_page: number, id: string, filter: string, searchParams?: string) => {
  const data = {
    page: page,
    per_page: per_page,
    order_by: filter
  }
  const searchObject = queryString.parse(searchParams);
  const queryParams = {...data, ...searchObject};
  const params = encodeData(queryParams);
  return authInstance.get(`employer-jobs/${id}?${params}`);
}

